import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

/* ── Formations ── */
export const fetchFormations = createAsyncThunk('formations/fetch', async (params = {}, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/formations/formations/', { params });
    return data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const createFormation = createAsyncThunk('formations/create', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/formations/formations/', payload);
    return data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const updateFormation = createAsyncThunk('formations/update', async ({ id, payload }, { rejectWithValue }) => {
  try {
    const { data } = await api.patch(`/formations/formations/${id}/`, payload);
    return data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const archiverFormation = createAsyncThunk('formations/archiver', async (id, { rejectWithValue }) => {
  try {
    await api.post(`/formations/formations/${id}/archiver/`);
    return id;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const activerFormation = createAsyncThunk('formations/activer', async (id, { rejectWithValue }) => {
  try {
    await api.post(`/formations/formations/${id}/activer/`);
    return id;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

/* ── Inscriptions ── */
export const fetchInscriptions = createAsyncThunk('formations/fetchInscriptions', async (params = {}, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/formations/inscriptions/', { params });
    return data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const createInscription = createAsyncThunk('formations/createInscription', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/formations/inscriptions/', payload);
    return data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const updateInscription = createAsyncThunk('formations/updateInscription', async ({ id, payload }, { rejectWithValue }) => {
  try {
    const { data } = await api.patch(`/formations/inscriptions/${id}/`, payload);
    return data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const supprimerInscription = createAsyncThunk('formations/supprimerInscription', async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/formations/inscriptions/${id}/`);
    return id;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

/* ── Slice ── */
const formationsSlice = createSlice({
  name: 'formations',
  initialState: {
    formations:   [],
    inscriptions: [],
    loading:      false,
    loadingIns:   false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* Formations */
      .addCase(fetchFormations.pending,  (s) => { s.loading = true; })
      .addCase(fetchFormations.fulfilled,(s, a) => {
        s.loading = false;
        const d = a.payload;
        s.formations = Array.isArray(d) ? d : (d?.results ?? []);
      })
      .addCase(fetchFormations.rejected, (s) => { s.loading = false; })

      /* Inscriptions */
      .addCase(fetchInscriptions.pending,  (s) => { s.loadingIns = true; })
      .addCase(fetchInscriptions.fulfilled,(s, a) => {
        s.loadingIns = false;
        const d = a.payload;
        s.inscriptions = Array.isArray(d) ? d : (d?.results ?? []);
      })
      .addCase(fetchInscriptions.rejected, (s) => { s.loadingIns = false; });
  },
});

export default formationsSlice.reducer;
